import { isWebServer } from "./constants";
var getDefaultRenderMode = function getDefaultRenderMode2() {
  var _ref;
  var _serverConfig_web;
  var CLIENT_RENDER_MODE = process.env.ONE_DEFAULT_RENDER_MODE;
  var serverConfig = globalThis["__vxrnPluginConfig__"];
  if (!CLIENT_RENDER_MODE && isWebServer && !serverConfig) {
    if (process.env.IS_VXRN_CLI) {
      throw new Error(`Internal one error: should call setServerConfig before createManifest`);
    }
  }
  return (_ref = CLIENT_RENDER_MODE !== null && CLIENT_RENDER_MODE !== void 0 ? CLIENT_RENDER_MODE : serverConfig === null || serverConfig === void 0 ? void 0 : (_serverConfig_web = serverConfig.web) === null || _serverConfig_web === void 0 ? void 0 : _serverConfig_web.defaultRenderMode) !== null && _ref !== void 0 ? _ref : "ssg";
};
export {
  getDefaultRenderMode
};
//# sourceMappingURL=config.js.map
